import type {BaseGraphNode} from "#graph/nodes/base/base-graph-node"
import type {SerializedGraphNode} from "#graph/serialization/types"
import {getRegisteredNode} from "#graph/decorators/register-node"
import {convertVersion} from "#graph/versioning/helpers"
import {deserializeGraphNodeWithFactory} from "#graph/serialization/deserialize-impl"

export function deserializeGraphNode(serializedGraph: SerializedGraphNode, namespace?: string): BaseGraphNode {
    return deserializeGraphNodeWithFactory(serializedGraph, ({$class, $version, parameters}) => {
        const NodeClass = getRegisteredNode($class, namespace)
        const definition = NodeClass.prototype.definition
        const versionedParameters = convertVersion(parameters, $version, definition.versionChain ?? [], definition.nodeClass)
        return new NodeClass({parameters: versionedParameters, disableValidation: true})
    })
}
